import { convertDate, convertOnlyTime } from "../../../utils/convertDate";
import { useReactToPrint } from "react-to-print";
import generatePDF from "react-to-pdf";
import { useRef } from "react";
import { useNavigate } from "react-router";

function StepsAllInfo({ data }) {
  const stepComponentRef = useRef();
  const navigate = useNavigate();

  const handlePrint = useReactToPrint({
    content: () => stepComponentRef.current,
    documentTitle: "Visitor Pass",
    bodyClass: "rtlDir",
    onAfterPrint: () => console.log("Printed PDF successfully!"),
  });

  return (
    <>
      <div className="w-11/12 mx-auto mt-12 flex items-center justify-between px-4">
        <div className="w-11/12 flex gap-3 items-center mx-auto">
          <button
            onClick={handlePrint}
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          >
            پرینت
          </button>
          <button
            onClick={() =>
              generatePDF(stepComponentRef, { filename: "page.pdf" })
            }
            type="button"
            className="focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
          >
            دانلود PDF
          </button>
        </div>
        <p
          onClick={() => navigate(-1)}
          className="opacity-0 cursor-pointer focus:outline-none text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
        >
          بازگشت
        </p>
      </div>

      <div className="w-11/12 mx-auto  border border-gray-200 rounded-lg my-6 bg-white shadow-sm p-6">
        <h3 className="mb-6">مراحل طی شده</h3>
        <div className="flex flex-col gap-6">
          {data?.steps?.length ? (
            data?.steps.map((item) => {
              return (
                <div
                  className="flex flex-col gap-2 p-4 text-sm rounded-lg bg-gray-50 dark:bg-gray-800 dark:text-gray-300"
                  role="alert"
                >
                  <span className="text-justify leading-6 text-gray-900">
                    - {item?.text}
                  </span>
                  <span className="text-xs text-gray-600">
                    در تاریخ {convertDate(item?.updatedAt, false)} در ساعت{" "}
                    {convertOnlyTime(item?.updatedAt)}
                  </span>
                </div>
              );
            })
          ) : (
            <div className="flex justify-center items-cneter py-10 rounded-xl shadow">
              <p>هنوز هیچ مرحله ای ثبت نشده است.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default StepsAllInfo;
